const escapeCsv = (value) => {
  const text = value == null ? "" : String(value);
  // Neutralise spreadsheet formula injection, then quote when needed
  const safe = /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;
  return /[",\n\r]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};

export const buildImportErrorsCsv = (errors = []) =>
  [
    "line,column,value,detail",
    ...errors.map((e) =>
      [e.line, e.column, e.value, e.detail].map(escapeCsv).join(",")
    ),
  ].join("\n");

export const downloadImportErrorsCsv = (errors, fileName) => {
  try {
    const blob = new Blob([buildImportErrorsCsv(errors)], {
      type: "text/csv;charset=utf-8;",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${(fileName || "import").replace(/\.csv$/i, "")}_errors.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (e) {
    console.error(e);
  }
};
